import { ROUTE_PATH_ACTIVATE, URL_INTX_LOGIN_PAGE_EN_CA } from '../../constants';
import { ScamDetectionPageTranslations } from '../types';

export const translations: ScamDetectionPageTranslations = {
  docTitle: 'Scam Detection',
  pageTitle: 'Scam Detection',
  featureList: [
    {
      // 'key' MUST BE the same as array index
      key: '0',
      heading: 'Stay one step ahead of fraudsters with AI-powered detection',
      summary: [
        '<p>In today&#39s digital world, scammers are using increasingly sophisticated tactics to steal your personal information. With Scan & Score, you can instantly analyze suspicious emails, texts, and links to detect potential scams before they cause harm. This proactive approach helps you make informed decisions and avoid becoming a victim of increasingly sophisticated scams. Plus, with AutoScan, you can set up automatic email monitoring, allowing Scan & Score to proactively identify potential threats in your inbox. This additional layer of protection works around the clock to help keep you safe from the latest fraud attempts.</p>',
        '<h2 class="feature-item-heading">AI-Powered Analysis</h2>',
        '<p>Submit any suspicious communication through our website or mobile app and receive an instant assessment. Scan & Score analyzes the content and provides you with a clear Scam Score indicating the level of risk, helping you identify potential threats before they can cause harm.</p>',
        '<br>'
      ].join('\n')
    },
    {
      key: '1',
      heading: 'Smart Risk Assessment',
      summary: [
        '<p>Every submission receives a comprehensive evaluation that analyzes multiple aspects of the communication to determine its legitimacy. You&#39ll receive a clear Scam Score rating (Low Risk, Risk Level Inconclusive, or High Risk) along with detailed contributing factors that explain why the communication may or may not be trustworthy.</p>',
        '<h2 class="feature-item-heading">Actionable Recommendations</h2>',
        '<p>Based on your Scam Score results, you&#39ll receive specific recommendations on how to protect yourself. These practical steps help you make informed decisions about how to handle suspicious communications and safeguard your personal information from potential threats.</p>',
        '<h2 class="feature-item-heading">Mobile Scam Detection</h2>',
        '<p>Access Scan & Score anytime, anywhere through our mobile app. This allows you to check suspicious messages the moment you receive them, providing immediate peace of mind wherever you go.</p>'
      ].join('\n'),
      action: {
        login: {
          to: '',
          href: URL_INTX_LOGIN_PAGE_EN_CA,
          children: 'Log In'
        },
        activate: {
                  to: ROUTE_PATH_ACTIVATE,
                  children: 'Activate'
        }
      }
    }
  ]
};
